<template>
  
</template>

<script>

export default {
  data() {
    return {
      ordernum:'',
      payConfig:{}
    };
  },
  created() {
        if(this.$route.query.ordernum!=undefined){
            this.ordernum=this.$route.query.ordernum;
            this.revokePay();
        }
  },
  methods:{
    revokePay(){
      this.$post("/wechatpay/getPreorder",{ordernum:this.ordernum}).then(data => {
        if(data.result.success){
            this.payConfig=data.result.info;
            if (typeof WeixinJSBridge == "undefined"){
                    if( document.addEventListener ){
                        document.addEventListener('WeixinJSBridgeReady', this.wxpay, false);
                    }else if (document.attachEvent){
                        document.attachEvent('WeixinJSBridgeReady', this.wxpay); 
                        document.attachEvent('onWeixinJSBridgeReady', this.wxpay);
                    }
                }else{
                    this.wxpay();
            }
        }else{
            this.$toast(data.result.info);
        }
      });
    },
    wxpay(){
          let that=this;
          WeixinJSBridge.invoke(
                'getBrandWCPayRequest',
                 {
                    "appId":this.payConfig.appId,     //公众号名称，由商户传入     
                    "timeStamp":this.payConfig.timeStamp,         //时间戳，自1970年以来的秒数     
                    "nonceStr":this.payConfig.nonceStr, //随机串     
                    "package":this.payConfig.package,     
                    "signType":this.payConfig.signType,         //微信签名方式：     
                    "paySign":this.payConfig.paySign
                 },
                function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok" ){
                              that.$router.replace({
                                    name: 'paymentresult',
                                    params: {
                                      status: 'success'
                                    }
                                  });
                  }else{
                           WeixinJSBridge.log(res.err_msg);
                                that.$router.replace({
                                    name: 'paymentresult',
                                    params: {
                                      status: 'fail'
                                    }
                                  });
                  }
                }
          );
    }
  }
  
};
</script>


